<template>
  <div>
    <b-form ref="mainForm" @submit="submitForm">
      <b-row class="mb-2">
        <b-col cols="12" lg="3" md="6">
          <span>Parent</span>
        </b-col>
        <b-col>
          <b-form-select v-model="formItem.parentId" size="sm" :options="folderOptions" :disabled="hasChildren"/>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col cols="12" lg="3" md="6">
          <span>Title</span>
        </b-col>
        <b-col>
          <div>
            <b-form-input v-model="formItem.title" maxlength="200" required size="sm"/>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button class="float-right" variant="primary" size="sm" @click="submitForm">Submit</b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>

</template>

<script>
import _ from 'lodash';

export default {
  name: "TableauFolderForm",
  props: {value: Object, folders: Array},
  mounted() {
    this.formItem = _.cloneDeep(this.value);
  },
  computed: {
    hasChildren() {
      return _.some(this.folders, {parentId: this.formItem.tableauMenuFolderId});
    },
    folderOptions() {
      let options = [{value: null, text: 'No Folder'}]
      let folders = _.filter(this.folders, folder => folder.tableauMenuFolderId !== this.formItem.tableauMenuFolderId);
      
      return [...options, ..._.map(folders, folder => {
        const id = folder.tableauMenuFolderId;
        let name = folder.title;
        while(folder.parentId != null)
        {
          const parent = _.find(this.folders, {tableauMenuFolderId: folder.parentId} )
          name = `${parent.title} / ${name}`;
          folder = parent;
        }
        return {value: id, text: name}
      })] 
    }
  },
  data() {
    return {
      formItem: {
        tableauMenuFolderId: null,
        title: '',
        parentId: null,
      },
    }
  },
  methods: {
    submitForm() {
      const form = this.$refs.mainForm;
      if(!form.reportValidity())
        return;
      
      this.$emit('submitForm', this.formItem);
    }
  }
}
</script>

<style scoped>

</style>

public long TableauMenuFolderId { get; set; }

[StringLength(200)]
public string Title { get; set; }
public long? ParentId {get;set;}